import React from "react";

const Privacy = () => {
  return (
    <div
      style={{
        paddingTop: "100px",
        paddingLeft: "20%",
        paddingRight: "20%",
        textAlign: "justify",
        color: "#000000",
      }}
    >
      <h1 style={{ textAlign: "center" }}>Notificação de privacidade</h1>
      <p>
        <h4>1. Introdução</h4>
      </p>
      <p>
        A Codekraft ( “Nós”, “Nos” ou “Nosso” ) está empenhada em proteger e
        respeitar a sua privacidade. Como parte de nossa operação comercial
        normal, coletamos certas informações pessoais de nossos clientes. Este
        aviso estabelece a base na qual processamos quaisquer informações
        pessoais que coletamos ou que você nos fornece. Por favor, leia este
        aviso cuidadosamente para entender Nossas práticas em relação às suas
        informações pessoais. Ao visitar www.alpisstudio.com,
        dashboard.alpisstudio.com (“Nossos sites”), você aceita e concorda com
        as práticas descritas neste aviso.
      </p>

      <p>
        <h4>2. O tipo de informação que coletamos</h4>
      </p>
      <p>
        <p>
          <h5>Podemos coletar e processar os seguintes dados sobre você:</h5>
        </p>
        <p>
          Informações que você nos fornece por meio do uso de nossos sites ou
          serviços. Você pode nos fornecer informações sobre você preenchendo
          formulários em nossos sites ou se correspondendo conosco por telefone,
          e-mail ou de outra forma. Isso inclui informações que você fornece
          quando se registra para usar nossos sites, se inscreve em nossos
          serviços, faz um pedido ou realiza uma transação em nossos sites ou
          relata um problema com nossos sites.
        </p>
        <p>
          <h5>As informações que você nos fornece podem incluir:</h5>
        </p>
        <ul>
          <li>
            Informações de contato, como seu nome, endereço, endereço de e-mail
            e número de telefone
          </li>
          <li>
            Informações de identificação, como documentos de identidade
            certificados, comprovante de endereço ou documentação comercial,
            incluindo seus dados pessoais
          </li>
          <li>Informações financeiras e de crédito</li>
          <li>
            Você pode nos fornecer informações relacionadas a beneficiários,
            acionistas, curadores e diretores para que possamos fornecer nossos
            serviços. Isso pode ser feito através do preenchimento de
            formulários em nossos sites ou por correspondência conosco por
            telefone, e-mail ou de outra forma. Você deve obter o consentimento
            apropriado antes de divulgar tais informações para Nós. As
            informações que você nos fornece podem incluir nome, endereço,
            endereço de e-mail e número de telefone, informações financeiras e
            de crédito.
          </li>
          <li>
            Você pode nos fornecer informações relacionadas a outras contas
            mantidas por outras instituições financeiras para que possamos
            fornecer nossos serviços. Isso pode ser feito por meio do
            preenchimento de formulários em nossos sites ou por correspondência
            conosco por telefone, e-mail ou de outra forma. Você deve obter o
            consentimento apropriado antes de divulgar tais informações para
            Nós. As informações que você nos fornece podem incluir o código do
            banco, o país do banco, o tipo de conta, o nome do banco e o número
            da conta.
          </li>
        </ul>
        <p>
          <h5>
            Informações que coletamos sobre você quando você usa nossos sites.
          </h5>
        </p>
        Com cada visita aos nossos sites, podemos coletar automaticamente as
        seguintes informações:
        <ul>
          <li>
            informações técnicas, incluindo o endereço de protocolo de internet
            (IP) usado para conectar seu computador à Internet, suas informações
            de login, tipo e versão do navegador, configuração de fuso horário,
            tipos e versões de plug-in do navegador, sistema operacional e
            plataforma;
          </li>
          <li>
            informações sobre sua visita, incluindo o fluxo de cliques completo
            do Uniform Resource Locators (URL) para, através e de Nossos sites
            (incluindo data e hora); produtos que você visualizou ou pesquisou;
            tempos de resposta da página, erros de download, duração das visitas
            a determinadas páginas, informações de interação da página (como
            rolagem, cliques e passagem do mouse) e métodos usados ​​para sair
            da página e de qualquer número de telefone usado para ligar para
            Nosso número de atendimento ao cliente .
          </li>
        </ul>
        <p>
          <h5>
            Informações que recebemos de outras fontes ao fornecer nossos
            serviços.
          </h5>
        </p>
        <ul>
          <li>
            Podemos receber informações sobre você se você usar qualquer outro
            site que operamos ou outros serviços que fornecemos. Esses dados
            podem ser compartilhados internamente e combinados com dados
            coletados neste site.
          </li>
          <li>
            Também trabalhamos em estreita colaboração com terceiros (incluindo,
            por exemplo, apresentadores, parceiros de negócios, subcontratados
            em serviços técnicos, de pagamento e entrega, redes de publicidade,
            provedores de análise, provedores de informações de pesquisa,
            agências de referência de crédito) e podemos receber informações
            sobre você de eles.
          </li>
        </ul>
        Onde recebemos informações Garantiremos que isso esteja em total
        conformidade com a Lei. O seus dados pessoas serão tratados, apenas e
        exclusivamente, para atender a finalidades específicas, em conformidade
        com as previsões da Lei 13.708/19 (LGPD).
      </p>

      <p>
        <h4>3. Cookies</h4>
      </p>
      <p>
        Seguimos a base do “consentimento expresso” para processar cookies. Na
        primeira vez que você visitar nossos sites, iremos informá-lo sobre os
        cookies que usamos e fornecer opções de aceitação que declaram seu
        consentimento para que possamos usar cookies. Alguns cookies são
        estritamente necessários para o funcionamento dos nossos sites.&nbsp;
      </p>
      <p>
        Um cookie é um arquivo de texto muito pequeno colocado em seu
        computador, que nos permite diferenciá-lo de outros usuários de nossos
        sites. Esses cookies nos ajudam a fornecer uma boa experiência ao
        navegar em nossos sites. Usamos os seguintes cookies:
      </p>
      <ul>
        <li>
          Cookies estritamente necessários. Estes são os cookies necessários
          para o funcionamento dos nossos sites. Eles incluem, por exemplo,
          cookies que permitem que você faça login em áreas seguras de nossos
          sites.
        </li>
        <li>
          Cookies analíticos/de desempenho. Eles nos permitem reconhecer e
          contar o número de visitantes e ver como os visitantes se movem em
          nossos sites quando os usam. Isso nos ajuda a melhorar a maneira como
          nossos sites funcionam, por exemplo, garantindo que os usuários
          encontrem o que procuram com facilidade.
        </li>
        <li>
          Cookies de funcionalidade. São usados ​​para reconhecê-lo quando você
          retorna aos nossos sites. Isso nos permite personalizar nosso conteúdo
          para você, lembrando suas preferências (por exemplo, sua escolha de
          idioma ou região).
        </li>
      </ul>
      <p>
        Observe que terceiros (incluindo, por exemplo, redes de publicidade e
        provedores de serviços externos, como serviços de análise de tráfego da
        web) também podem usar cookies, sobre os quais não temos controle. Esses
        cookies provavelmente são cookies analíticos/de desempenho ou cookies de
        direcionamento.
      </p>
      <p>
        Você pode bloquear cookies ativando a configuração em seu navegador que
        permite recusar a configuração de todos ou alguns cookies. No entanto,
        se você usar as configurações do navegador para bloquear todos os
        cookies (incluindo cookies essenciais), talvez não consiga acessar todos
        ou partes de nossos sites.
      </p>
      <p>&nbsp;</p>
      <p>
        <h4>4. Como usamos suas informações</h4>
      </p>
      <p>
        Informações que você nos fornece. Usaremos essas informações conforme
        reconhecido e em conformidade com as leis de proteção de dados
        aplicáveis:
      </p>
      <ul>
        <li style={{ listStyleType: "none" }}>
          <ul>
            <li>
              para cumprir Nossas obrigações decorrentes de quaisquer contratos
              celebrados entre você e Nós e para fornecer informações, produtos
              e serviços que você solicitar de Nós
            </li>
            <li>
              para cumprir Nossas obrigações decorrentes de quaisquer contratos
              celebrados entre Nós e terceiros relacionados aos serviços
              prestados a Você
              <ul>
                <li>
                  Suas informações serão usadas apenas nessas circunstâncias na
                  execução de um contrato com Você
                </li>
                <li>
                  onde exista um interesse legítimo definido, para efeitos de
                  acompanhamento da relação contratual entre Nós e os terceiros
                  envolvidos na relação consigo; e
                </li>
                <li>
                  quando o processamento for do interesse legítimo da Codekraft
                  ou de outra parte, e esses interesses não forem substituídos
                  por Seus interesses ou direitos na proteção de Seus dados
                  pessoais. Isso pode incluir o processamento de seus dados para
                  (i) identificação ou prevenção de transações suspeitas ou de
                  alto risco ou atividades fraudulentas, pesquisas internas e
                  avaliações analíticas, (ii) para fins de comunicação com você
                  e (iii) para informá-lo sobre novos produtos e serviços que
                  estão oferecendo ou promovendo novos produtos e serviços de
                  outras partes que achamos que podem ser de seu interesse.
                  Antes de processarmos seus dados pessoais para buscar nossos
                  interesses legítimos para os fins descritos nesta política,
                  determinamos se tal processamento é necessário e consideramos
                  cuidadosamente o impacto de nossas atividades de processamento
                  em seus direitos e liberdades fundamentais.
                </li>
              </ul>{" "}
            </li>
            <li>
              para lhe fornecer informações sobre outros produtos e serviços que
              oferecemos
              <ul>
                <li>
                  se você for um cliente particular existente, entraremos em
                  contato apenas com informações sobre produtos e serviços
                  semelhantes aos que foram objeto de uma venda anterior ou
                  negociações de uma venda para você.
                </li>
                <li>
                  onde você é um novo cliente particular, entraremos em contato
                  somente se você consentir com isso. Se você não deseja que
                  usemos seus dados dessa maneira, marque a caixa relevante
                  situada no formulário no qual coletamos seus dados.
                </li>
                <li>
                  onde você é um cliente corporativo/empresarial, entraremos em
                  contato com você quando identificarmos um interesse legítimo
                  em relação aos serviços que oferecemos e ao seu negócio.
                </li>
                <li>
                  Você pode retirar esse consentimento a qualquer momento usando
                  os links fornecidos na parte inferior dos e-mails de marketing
                  enviados por nós ou entrando em contato com nosso DPO.
                </li>
              </ul>{" "}
            </li>
            <li>Para notificá-lo sobre alterações no nosso serviço</li>
            <li>
              para responder a qualquer consulta que você tenha feito através de
              Nossos sites, ou por telefone, e-mail ou de outra forma.
            </li>
            <li>
              para cumprir as obrigações legais a que estamos sujeitos como
              controlador de dados e empresa regulamentada. Isso inclui:
              <ul>
                <li>
                  usar as informações pessoais necessárias para cumprir os
                  deveres legais e reguladores relacionados à lavagem de
                  dinheiro e ao financiamento do terrorismo
                </li>
                <li>
                  detectar, prevenir e processar fraude ou roubo, bem como
                  prevenir o uso ilegítimo ou proibido de nossos serviços ou
                  outras atividades ilegais ou ilícitas.
                </li>
                <li>monitorar e relatar problemas de conformidade.</li>
                <li>
                  Isso pode incluir ainda o uso de suas informações pessoais
                  para validar e autenticar sua identidade e a utilização de
                  terceiros para nos ajudar a fazer isso. Consulte as
                  informações que divulgamos sobre você.
                </li>
              </ul>{" "}
            </li>
            <li>
              quando necessário para proteger seus interesses vitais ou de outra
              pessoa física
            </li>
            <li>
              quando realizando tarefas realizadas no interesse público ou no
              exercício da autoridade oficial investida em Nós
            </li>
          </ul>{" "}
        </li>
      </ul>
      <p>&nbsp;</p>
      <p>
        Informações que recebemos de outras fontes. – Usaremos essas
        informações:
      </p>
      <p>
        Podemos combinar essas informações com informações que você nos fornece
        e informações que coletamos sobre você. Podemos usar essas informações e
        as informações combinadas para os fins descritos acima (dependendo dos
        tipos de informações que recebemos).
      </p>
      <p>&nbsp;</p>
      <p>Informações que divulgamos sobre você</p>
      <p>
        Podemos compartilhar suas informações pessoais com qualquer membro de
        Nosso grupo, o que significa Nossas filiais, Nossos escritórios de
        representação, Nossas subsidiárias, Nossa holding final e suas
        subsidiárias. Qualquer compartilhamento será considerado feito em plena
        conformidade com a Lei.
      </p>
      <p>
        Nunca venderemos os seus dados pessoais sem o seu consentimento. Podemos
        compartilhar suas informações com terceiros selecionados; quando
        necessário, somos obrigados a cumprir todos os aspectos da Lei. A seguir
        estão os tipos de organizações com as quais podemos compartilhar algumas
        de suas informações pessoais:
      </p>
      <ul>
        <li style={{ listStyleType: "none" }}>
          <ul>
            <li style={{ listStyleType: "none" }}>
              <ul>
                <li style={{ listStyleType: "none" }}>
                  <ul>
                    <li>
                      Parceiros de negócios, fornecedores e subcontratados para
                      a execução de qualquer contrato que celebramos com eles ou
                      com você.
                    </li>
                    <li>
                      Provedores de mecanismos de pesquisa e análises que nos
                      auxiliam na melhoria e otimização de nossos sites.
                    </li>
                    <li>
                      Agências de referência de crédito com a finalidade de
                      avaliar sua pontuação de crédito, quando esta for uma
                      condição para que possamos celebrar um contrato com você.
                    </li>
                    <li>
                      Quando você fornece consentimento, os serviços de
                      Verificação de Identidade com a finalidade de confirmar
                      sua identidade por meio de aplicativos online
                    </li>
                  </ul>{" "}
                </li>
              </ul>{" "}
            </li>
          </ul>{" "}
        </li>
      </ul>
      <ul>
        <li style={{ listStyleType: "none" }}>
          <ul>
            <li style={{ listStyleType: "none" }}>
              <ul style={{ listStyleType: "circle" }}>
                <li>
                  Polícia e agências de aplicação da lei, quando exigido por
                  lei.
                </li>
                <li>
                  Somos participantes do provedor de serviços de pagamento
                  (“PSPs”) da Amazon. Programa que é projetado para melhorar sua
                  capacidade de detectar, prevenir e tomar medidas contra maus
                  atores para que a Amazon e os PSPs participantes possam
                  continuar a proteger clientes e vendedores contra fraudes e
                  abusos. Como um PSP, se sua conta Alpis Studio estiver
                  registrada na Amazon, compartilharemos com a Amazon certos
                  dados coletados durante o processo de integração conosco e
                  conforme você usa nossos Serviços. Isso pode incluir dados
                  coletados por nós, como dados de identificação, informações de
                  contato e detalhes sobre suas contas na plataforma Alpis
                  Studio e sua conta bancária. Se a Amazon desativar ou encerrar
                  sua conta com eles devido a (i) abuso, fraude, atividade
                  ilegal, (ii) violação de seus termos e condições ou (iii) a
                  Amazon iniciar um litígio ou ação de execução contra você,
                  poderemos compartilhar informações adicionais
                </li>
              </ul>{" "}
            </li>
          </ul>{" "}
        </li>
      </ul>
      <p>&nbsp;</p>
      <p>Podemos divulgar suas informações pessoais a terceiros:</p>
      <ul>
        <li style={{ listStyleType: "none" }}>
          <ul>
            <li style={{ listStyleType: "none" }}>
              <ul>
                <li style={{ listStyleType: "none" }}>
                  <ul>
                    <li style={{ listStyleType: "none" }}>
                      <ul>
                        <li>
                          No caso de vendermos ou comprarmos qualquer negócio ou
                          ativos, caso em que podemos divulgar suas informações
                          pessoais ao potencial vendedor ou comprador de tais
                          negócios ou ativos.
                        </li>
                        <li>
                          Se a Codekraft ou substancialmente todos os seus
                          ativos forem adquiridos por terceiros, caso em que as
                          informações pessoais mantidas por ela sobre seus
                          clientes serão um dos ativos transferidos.
                        </li>
                        <li>
                          Se tivermos o dever de divulgar ou compartilhar suas
                          informações pessoais para cumprir qualquer obrigação
                          legal ou para fazer cumprir ou aplicar nossos termos
                          de uso ou termos e condições e outros acordos; ou para
                          proteger os direitos, propriedade ou segurança de Nós,
                          das empresas do nosso grupo, clientes ou outros. Isso
                          inclui a troca de informações com outras empresas e
                          organizações para fins de proteção contra fraudes e
                          redução do risco de crédito.
                        </li>
                      </ul>{" "}
                    </li>
                  </ul>{" "}
                </li>
              </ul>{" "}
            </li>
          </ul>{" "}
        </li>
      </ul>
      <p>&nbsp;</p>
      <p>
        <h4>5. Onde armazenamos suas informações pessoais</h4>
      </p>
      <p>
        Os dados que coletamos de você podem ser transferidos e armazenados em
        um destino fora do Brasil (“BR”). Também pode ser processado por
        funcionários que operam fora do Brasil e que trabalham para nós ou para
        um de nossos fornecedores. Essa equipe pode estar envolvida, entre
        outras coisas, no atendimento de seu pedido, no processamento de seus
        detalhes de pagamento e na prestação de serviços de suporte. Quando
        essas transferências forem necessárias, elas serão feitas em total
        conformidade com a Lei.
      </p>
      <p>
        Especificamente, podemos transferir seus dados para o Espaço Econômico
        Europeu ("EEA") ou para os EUA.
      </p>
      <p>
        Quando os dados são transferidos para outra jurisdição, isso é feito de
        acordo com as leis de proteção de dados relevantes, apoiadas pelo uso de
        cláusulas contratuais padrão para transferências internas da Codekraft.
        Em relação às transferências para os EUA, podemos transferir informações
        pessoais por meio do uso de cláusulas contratuais padrão e medidas
        adicionais conforme necessário.
      </p>
      <p>
        Todas as suas informações pessoais terão um alto nível de proteção onde
        quer que sejam processadas e independentemente de serem mantidas por nós
        ou por nossos contratados ou agentes.
      </p>
      <p>
        Todas as informações que você nos fornece são armazenadas sob nosso
        controle. Todas as transações de pagamento serão criptografadas. Quando
        lhe fornecemos (ou quando você escolheu) uma senha que lhe permite
        acessar certas partes do nosso site, você é responsável por manter essa
        senha confidencial. Pedimos que você não compartilhe uma senha com
        ninguém.
      </p>
      <p>
        Infelizmente, a transmissão de informações pela internet não é
        totalmente segura. Embora façamos o possível para proteger suas
        informações pessoais, não podemos garantir a segurança de seus dados
        transmitidos ao nosso site; qualquer transmissão é por sua conta e
        risco. Assim que recebermos suas informações, usaremos procedimentos
        rígidos e recursos de segurança para tentar impedir o acesso não
        autorizado.
      </p>
      <p>
        Se você tiver dúvidas específicas sobre um método de transmissão de
        dados, tomaremos medidas razoáveis ​​para fornecer um método
        alternativo.
      </p>

      <p>
        <h4>6. Seus direitos</h4>
      </p>
      <p>
        A Lei Geral de Proteção de Dados – Lei 13.709/18 destinou o seu Capítulo
        III para previsões acerca dos direitos dos titulares de dados, os quais
        estão elencados no artigo 18 da referida Lei.
      </p>
      <p>
        Você pode entrar em contato com Nosso Diretor de Proteção de Dados,
        contato@alpisstudio.com, para exercer seus direitos. Ao exercer os seus
        direitos, iremos sempre informá-lo de qualquer motivo legal que possa
        exigir que continuemos a processar os seus dados.
      </p>
      <p>
        Você tem o direito de nos solicitar informações sobre se processamos
        suas informações pessoais e fazer perguntas sobre como coletamos,
        armazenamos e processamos essas informações.
      </p>
      <p>
        Você tem o direito de acessar informações gratuitas sobre as informações
        pessoais que mantemos sobre você, sejam elas transferidas para um país
        terceiro ou organização internacional e as salvaguardas associadas.
      </p>
      <p>
        Você tem o direito de receber quaisquer dados pessoais que mantemos
        sobre você em um formato comumente usado e legível por máquina.
      </p>
      <p>
        Quando as informações que possuímos não forem precisas ou estiverem
        incompletas, você tem o direito de solicitar que corrijamos essas
        informações e faremos isso sem demora indevida.
      </p>
      <p>
        Você tem o direito de solicitar que excluamos quaisquer dados que
        processamos sobre você, quando o processamento não for mais necessário.
      </p>
      <p>
        Onde você já deu consentimento para o nosso processamento de seus dados,
        você tem o direito de remover esse consentimento e de nós pararmos de
        processar seus dados específicos para esse consentimento. Você também
        tem o direito de se opor ao nosso processamento de seus dados.
      </p>

      <p>
        <h4>7. Sites Externos</h4>
      </p>
      <p>
        Nosso site pode, de tempos em tempos, conter links de e para os sites de
        nossas redes parceiras, anunciantes e afiliados. Se você seguir um link
        para qualquer um desses sites, observe que esses sites têm suas próprias
        políticas de privacidade e que não aceitamos qualquer responsabilidade
        ou obrigação por essas políticas. Verifique essas políticas antes de
        enviar qualquer informação pessoal a esses sites.
      </p>

      <p>
        <h4>8. Retendo seus dados</h4>
      </p>
      <p>
        O período pelo qual reteremos seus dados depende de quaisquer períodos
        de retenção estatutários que somos obrigados a cumprir como uma
        organização regulamentada. Após a expiração desse período, os dados
        pessoais serão excluídos com segurança, desde que não sejam mais
        necessários para o cumprimento de qualquer contrato, início de um
        contrato ou em relação a outros procedimentos legais.
      </p>

      <p>
        <h4>11. Alterações à nossa política de privacidade</h4>
      </p>
      <p>
        Este Aviso foi atualizado pela última vez em 09 de janeiro de 2023.
        Quaisquer alterações que possamos fazer em Nosso aviso de privacidade no
        futuro serão publicadas nesta página e, quando apropriado, notificadas a
        você por e-mail. Por favor, volte com frequência para ver quaisquer
        atualizações ou alterações em nosso aviso de privacidade.
      </p>
    </div>
  );
};

export default Privacy;
